import React from 'react'
import classes from './EKGPreview.css'
import Grid from '../../components/Grid'
import Waveform from '../../components/Waveform'
import * as Lib from '../../constants/RecordingConstants'

export const EKGPreview = props => {
  const {
    inverted,
    previewData: {
      frequency,
      samples: {
        leadI,
      },
    },
    height: h,
  } = props

  const seconds = 6
  const width = seconds * Lib.PX_PER_SECOND
  const height = 200

  return (
    <div className={classes.eKGPreview}>
      <svg width={width} height={height} className={classes.previewGrid}>
        <g transform="translate(0,0)">
          <Grid
            renderSmallGrid={false}
            rowSeconds={seconds}
            stripWidthPx={width}
            height={height}
          />
          <Waveform
            height={height}
            samples={leadI}
            inverted={inverted}
            mainsFreq={60}
          />
        </g>
      </svg>
    </div>
  )
}

export default EKGPreview



// WEBPACK FOOTER //
// ./src/legacy/components/EKGPreview/EKGPreview.jsx